import { render, staticRenderFns } from "./checkboxPrivacy.vue?vue&type=template&id=6125b8c8&scoped=true&"
import script from "./checkboxPrivacy.vue?vue&type=script&lang=js&"
export * from "./checkboxPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./checkboxPrivacy.vue?vue&type=style&index=0&id=6125b8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125b8c8",
  null
  
)

export default component.exports